import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api.js';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => {
        // Don't retry auth/permission/validation errors.
        if (err instanceof ApiError && [400, 401, 403, 404].includes(err.status)) return false;
        return count < 2;
      },
    },
  },
});
